export default __webpack_public_path__ + "static/media/z.571cce4a.mp4";